import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { NavigationEntryComponent } from './components/navigation-entry/navigation-entry.component';
import { NavigationComponent } from './navigation.component';

@NgModule({
  declarations: [NavigationComponent, NavigationEntryComponent],
  exports: [NavigationComponent],
  imports: [SharedModule, RouterModule]
})
export class NavigationModule {}
